<div class="m-grid__item m-grid__item--fluid m-wrapper m-grid-responsive-lg">
  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
  </ngx-spinner>

  <!--MAIN-->
  <div class="m-content">
    <!--begin::Portlet-->
    <div class="row m-row">
      <div class="col-lg-8">
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  ULTRASONIC PUSH NOTIFICATION
                </h3>
                <span style="color: lightgray; vertical-align: middle; display: table-cell; text-align: right;" class="m-portlet__head-text" *ngIf="serviceId > 0">
                  {{serviceId}}
                </span>
              </div>
            </div>
          </div>

          <!--begin::Form-->
          <form
            *ngIf="form"
            [formGroup]="form"
            class="m-form m-form--fit m-form--label-align-right"
          >
            <div class="m-portlet__body">
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Title: </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="title"
                  />
                  <app-validation-display
                    [control]="form.controls.title"
                  ></app-validation-display>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"> Cool Down Time: </label>
                <div class="col-lg-6">
                  <input
                    type="number"
                    class="form-control m-input"
                    formControlName="cooldown"
                  />
                  <app-validation-display
                    [control]="form.controls.cooldown"
                  ></app-validation-display>
                </div>

                <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      class="tooltip-icon"
                      style="position: relative; top: 5px"
                      tooltip="Users can only receive the UPN once within this time period before they can receive another"
                    />
              </div>

              <div
                *ngIf="showServicePeriod"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Active period:
                </label>
                <div class="col-lg-8">
                  <app-service-period
                    [minDays]="30"
                    formControlName="activePeriod"
                  ></app-service-period>
                </div>
              </div>

              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Type
                </label>
                <div class="col-lg-6">
                  <ng-select
                    (change)="viewTypeChange()"
                    formControlName="type"
                    value="form.get('type').value"
                    [searchable]="false"
                    [clearable]="false"
                  >
                    <ng-option *ngFor="let elem of upnTypeList" [value]="elem">
                      {{ elem }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>

              <div
                class="form-group m-form__group row"
                *ngIf="
                  form.get('type').value === 'Image' &&
                  form.get('secondImage').value
                "
              >
                <label class="col-lg-4 col-form-label">
                  Autoswipe
                </label>
                <div class="col-lg-2 startdateinput">
                  <label class="switch">
                    <input
                      formControlName="autoswipe"
                      type="checkbox"
                      class="form-control"
                      style="display:none"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                *ngIf="form.get('type').value === 'Map View'"
              >
                <label class="col-lg-4 col-form-label">Location Title: </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="locationTitle"
                  />
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                *ngIf="form.get('type').value === 'Map View'"
              >
                <label class="col-lg-4 col-form-label"
                  >Location Subtitle:
                </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="locationSubtitle"
                  />
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                *ngIf="form.get('type').value === 'Map View'"
              >
                <label class="col-lg-4 col-form-label">Latitude: </label>
                <div class="col-lg-6">
                  <input
                    [required]="form.get('type').value === 'Map View'"
                    type="number"
                    class="form-control m-input"
                    formControlName="lat"
                    (change)="markerUpdate()"
                  />
                  <app-validation-display
                    [control]="form.controls.lat"
                  ></app-validation-display>
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                *ngIf="form.get('type').value === 'Map View'"
              >
                <label class="col-lg-4 col-form-label">Longitude: </label>
                <div class="col-lg-6">
                  <input
                    [required]="form.get('type').value === 'Map View'"
                    type="number"
                    class="form-control m-input"
                    formControlName="lng"
                    (change)="markerUpdate()"
                  />
                  <app-validation-display
                    [control]="form.controls.lng"
                  ></app-validation-display>
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                *ngIf="form.get('type').value === 'Web View'"
              >
                <label class="col-lg-4 col-form-label">Url to display: </label>
                <div class="col-lg-6">
                  <input
                    [required]="form.get('type').value === 'Web View'"
                    type="text"
                    class="form-control m-input"
                    formControlName="iframeUrl"
                  />
                  <app-validation-display
                    [control]="form.controls.iframeUrl"
                    errorMessage="The URL is invalid or not secure."
                  >
                  </app-validation-display>
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                [hidden]="form.get('type').value !== 'Image'"
              >
                <label class="col-lg-4 col-form-label"> Upload Image </label>
                <div class="col-lg-6">
                  <label
                    #firstDropZone
                    for="file-1"
                    class="frame1-bottom-image-container"
                  >
                    <div
                      *ngIf="isOnTopOfFirstZone; else notDraggedFirst"
                      class="zone-upload-message"
                    >
                      Drop image to upload
                    </div>

                    <ng-template #notDraggedFirst>
                      <input
                        [required]="form.get('type').value === 'Image'"
                        type="file"
                        (change)="firstImageHandler($event.target.files)"
                        name="file-1[]"
                        id="file-1"
                        class="inputfile inputfile-3"
                        data-multiple-caption="{count} files selected"
                        accept="image/x-png,image/gif,image/jpeg"
                      />
                      <img
                        [src]="
                          form.get('firstImage').value || uploadPlaceholderImage
                        "
                        class="frame1-bottom-image"
                        height="150"
                        width="100"
                      />
                    </ng-template>
                  </label>
                  <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      class="tooltip-icon"
                      style="position: relative; top: 5px"
                      tooltip="Recommended size 1334x750 px."
                    />
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                [hidden]="
                  !form.get('firstImage').value ||
                  form.get('type').value !== 'Image'
                "
              >
                <label class="col-lg-4 col-form-label">
                  Upload Image for second slide
                </label>
                <div class="col-lg-6">
                  <label
                    #secondDropZone
                    for="file-2"
                    class="frame1-bottom-image-container"
                  >
                    <div
                      *ngIf="isOnTopOfSecondZone; else notDraggedSecond"
                      class="zone-upload-message"
                    >
                      Drop image to upload
                    </div>

                    <ng-template #notDraggedSecond>
                      <input
                        type="file"
                        (change)="secondImageHandler($event.target.files)"
                        name="file-2[]"
                        id="file-2"
                        class="inputfile inputfile-3"
                        data-multiple-caption="{count} files selected"
                        accept="image/x-png,image/gif,image/jpeg"
                      />
                      <img
                        [src]="
                          form.get('secondImage').value ||
                          uploadPlaceholderImage
                        "
                        class="frame1-bottom-image"
                        height="150"
                        width="100"
                      />
                    </ng-template>
                  </label>
                  <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      class="tooltip-icon"
                      style="position: relative; top: 5px"
                      tooltip="Recommended size 1334x750 px."
                    />
                </div>
              </div>
              <div
                class="form-group m-form__group row"
                [hidden]="!form.get('secondImage').value"
              >
              <!-- TODO: FIX ME -->
                <label class="col-lg-4 col-form-label">
                  Upload Image for third slide
                </label>
                <div class="col-lg-6">
                  <label
                    #thirdDropZone
                    for="file-3"
                    class="frame1-bottom-image-container"
                  >
                    <div
                      *ngIf="isOnTopOfThirdZone; else notDraggedThird"
                      class="zone-upload-message"
                    >
                      Drop image to upload
                    </div>

                    <ng-template #notDraggedThird>
                      <input
                        type="file"
                        (change)="thirdImageHandler($event.target.files)"
                        name="file-3[]"
                        id="file-3"
                        class="inputfile inputfile-3"
                        data-multiple-caption="{count} files selected"
                        accept="image/x-png,image/gif,image/jpeg"
                      />
                      <img
                        [src]="
                          form.get('thirdImage').value || uploadPlaceholderImage
                        "
                        class="frame1-bottom-image"
                        height="150"
                        width="100"
                      />
                    </ng-template>
                  </label>
                  <img
                      src="../../assets/app/media/img/icons/info-icon.png"
                      class="tooltip-icon"
                      style="position: relative; top: 5px"
                      tooltip="Recommended size 1334x750 px."
                    />
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label"
                  >Close button label:
                </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    class="form-control m-input"
                    formControlName="dismissText"
                  />
                  <app-validation-display
                    [control]="form.controls.dismissText"
                  ></app-validation-display>
                </div>
              </div>
              <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  BLE Push Notification Enabled:
                </label>
                <div class="col-lg-6">
                  <label class="switch">
                    <input
                      (change)="enableBleChange()"
                      formControlName="bleEnabled"
                      type="checkbox"
                      class="form-control"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div
                *ngIf="form.controls.bleEnabled.value === true"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Notification Title:
                </label>
                <div class="col-lg-6">
                  <input
                    [requiredIf]="form.controls.bleEnabled.value === true"
                    type="text"
                    maxlength="40"
                    class="form-control m-input"
                    formControlName="bleTitle"
                  />
                  <app-validation-display
                    errorMessage="Required for BLE notifications"
                    [control]="form.controls.bleTitle"
                  ></app-validation-display>
                </div>
              </div>
              <div
                *ngIf="form.controls.bleEnabled.value === true"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Notification Subtitle:
                </label>
                <div class="col-lg-6">
                  <input
                    type="text"
                    maxlength="40"
                    class="form-control m-input"
                    formControlName="bleSubtitle"
                  />
                </div>
              </div>
              <div
                *ngIf="form.controls.bleEnabled.value === true"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Notification Message:
                </label>
                <div class="col-lg-6">
                  <textarea
                    rows="2"
                    [requiredIf]="form.controls.bleEnabled.value === true"
                    type="text"
                    maxlength="120"
                    class="form-control m-input"
                    formControlName="bleBody"
                  ></textarea>
                  <app-validation-display
                    errorMessage="Required for BLE notifications"
                    [control]="form.controls.bleBody"
                  ></app-validation-display>
                </div>
              </div>
              <div
                *ngIf="form.controls.bleEnabled.value === true"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Tap Notification to Open:
                </label>
                <div class="col-lg-6">
                  <label class="switch">
                    <input
                      formControlName="bleShowOnTap"
                      type="checkbox"
                      class="form-control"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div
                *ngIf="hasSiteManagement && id > 0"
                class="form-group m-form__group row"
              >
                <label class="col-lg-4 col-form-label">
                  Regenerate Audio on Update:
                </label>
                <div class="col-lg-6">
                  <label class="switch">
                    <input
                      formControlName="regenerateAudio"
                      type="checkbox"
                      class="form-control"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div
              *ngIf="hasSiteManagement"
              class="form-group m-form__group row"
            >
              <label class="col-lg-4 col-form-label">
                Use Audible Triggers:
              </label>
              <div class="col-lg-6">
                <label class="switch">
                  <input
                    formControlName="useAudible"
                    type="checkbox"
                    class="form-control"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
              <div class="form-group m-form__group row">
                <div class="col-lg-6">
                  <div>
                    <label>Button One</label>
                  </div>
                  <div>
                    <label> Type </label>
                    <ng-select
                      (change)="firstButtonTypeChange()"
                      formControlName="firstButtonType"
                      [searchable]="false"
                      [clearable]="false"
                    >
                      <ng-option value="">
                        Disabled (Button won't appear)
                      </ng-option>
                      <ng-option value="openMaps">
                        Open Maps
                      </ng-option>
                      <ng-option value="openUrl">
                        Open Url
                      </ng-option>
                      <ng-option
                        *ngIf="coupons && coupons.length > 0"
                        value="openCoupon"
                      >
                        Coupon
                      </ng-option>
                    </ng-select>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value">
                    <label> Text </label>
                    <input
                      required
                      type="text"
                      class="form-control m-input"
                      formControlName="firstButtonText"
                      [placeholder]="
                        form.get('firstButtonType').value === 'openMaps'
                          ? 'Open Maps'
                          : ''
                      "
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonText"
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('firstButtonType').value === 'openCoupon'"
                  >
                    <label> Coupon </label>
                    <select
                      formControlName="coupon1Select"
                      class="form-control m-input"
                      id="coupon1Select"
                      name="coupons"
                    >
                      <option
                        style="color:black;"
                        *ngFor="let coupon of coupons | orderBy: 'description'"
                        [selected]="
                          coupon.id == form.controls.coupon1Select.value
                        "
                        [ngValue]="coupon.id"
                      >
                        {{ coupon.description }} - {{ coupon.primaryFieldBody }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value === 'openUrl'">
                    <label> Url </label>
                    <input
                      [required]="
                        form.get('firstButtonType').value === 'openUrl'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="firstButtonUrl"
                      placeholder=""
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonUrl"
                    ></app-validation-display>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value === 'openMaps'">
                    <label> Latitude </label>
                    <input
                      [required]="
                        form.get('firstButtonType').value === 'openMaps'
                      "
                      type="number"
                      class="form-control m-input"
                      formControlName="firstButtonLat"
                      placeholder="12.263145"
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonLat"
                    ></app-validation-display>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value === 'openMaps'">
                    <label> Longitude </label>
                    <input
                      [required]="
                        form.get('firstButtonType').value === 'openMaps'
                      "
                      type="number"
                      class="form-control m-input"
                      formControlName="firstButtonLng"
                      placeholder="43.255545"
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonLng"
                    ></app-validation-display>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value === 'openMaps'">
                    <label> Location Title </label>
                    <input
                      [required]="
                        form.get('firstButtonType').value === 'openMaps'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="firstButtonLocationTitle"
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonLocationTitle"
                    ></app-validation-display>
                  </div>
                  <div *ngIf="form.get('firstButtonType').value === 'openMaps'">
                    <label> Location Subtitle </label>
                    <input
                      [required]="
                        form.get('firstButtonType').value === 'openMaps'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="firstButtonLocationSubtitle"
                    />
                    <app-validation-display
                      [control]="form.controls.firstButtonLocationSubtitle"
                    ></app-validation-display>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div>
                    <label>Button Two</label>
                  </div>
                  <div>
                    <label> Type </label>
                    <ng-select
                      (change)="secondButtonTypeChange()"
                      formControlName="secondButtonType"
                      [searchable]="false"
                      [clearable]="false"
                    >
                      <ng-option value="">
                        Disabled (Button won't appear)
                      </ng-option>
                      <ng-option value="openMaps">
                        Open Maps
                      </ng-option>
                      <ng-option value="openUrl">
                        Open Url
                      </ng-option>
                      <ng-option
                        *ngIf="coupons && coupons.length > 0"
                        value="openCoupon"
                      >
                        Coupon
                      </ng-option>
                    </ng-select>
                  </div>
                  <div *ngIf="form.get('secondButtonType').value">
                    <label> Text </label>
                    <input
                      required
                      type="text"
                      class="form-control m-input"
                      formControlName="secondButtonText"
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonText"
                      [placeholder]="
                        form.get('secondButtonType').value === 'openMaps'
                          ? 'Open Maps'
                          : ''
                      "
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('secondButtonType').value === 'openCoupon'"
                  >
                    <label> Coupon </label>
                    <select
                      formControlName="coupon2Select"
                      class="form-control m-input"
                      id="coupon2Select"
                      name="coupons"
                    >
                      <option
                        style="color:black;"
                        *ngFor="let coupon of coupons | orderBy: 'description'"
                        [selected]="
                          coupon.id == form.controls.coupon2Select.value
                        "
                        [ngValue]="coupon.id"
                      >
                        {{ coupon.description }} - {{ coupon.primaryFieldBody }}
                      </option>
                    </select>
                  </div>
                  <div *ngIf="form.get('secondButtonType').value === 'openUrl'">
                    <label> Url </label>
                    <input
                      [required]="
                        form.get('secondButtonType').value === 'openUrl'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="secondButtonUrl"
                      placeholder=""
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonUrl"
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('secondButtonType').value === 'openMaps'"
                  >
                    <label> Latitude </label>
                    <input
                      [required]="
                        form.get('secondButtonType').value === 'openMaps'
                      "
                      type="number"
                      class="form-control m-input"
                      formControlName="secondButtonLat"
                      placeholder="12.263145"
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonLat"
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('secondButtonType').value === 'openMaps'"
                  >
                    <label> Longitude </label>
                    <input
                      [required]="
                        form.get('secondButtonType').value === 'openMaps'
                      "
                      type="number"
                      class="form-control m-input"
                      formControlName="secondButtonLng"
                      placeholder="43.255545"
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonLng"
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('secondButtonType').value === 'openMaps'"
                  >
                    <label> Location Title </label>
                    <input
                      [required]="
                        form.get('secondButtonType').value === 'openMaps'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="secondButtonLocationTitle"
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonLocationTitle"
                    ></app-validation-display>
                  </div>
                  <div
                    *ngIf="form.get('secondButtonType').value === 'openMaps'"
                  >
                    <label> Location Subtitle </label>
                    <input
                      [required]="
                        form.get('secondButtonType').value === 'openMaps'
                      "
                      type="text"
                      class="form-control m-input"
                      formControlName="secondButtonLocationSubtitle"
                    />
                    <app-validation-display
                      [control]="form.controls.secondButtonLocationSubtitle"
                    ></app-validation-display>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text coupon-preview-header">
                  UPN Preview
                </h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="upn-preview">
              <app-iphone-frame
                [styleOverride]="{'background': '#696969', 'color': '#fff' }"
                style="transform: translateX(14px)"
                imageUri="assets/app/media/img/misc/upn-bg.png"
              >
                <div
                  class="imageview"
                  [hidden]="form?.get('type').value !== 'Image'"
                >
                  <img
                    *ngIf="form?.get('firstImage').value"
                    [hidden]="form?.get('secondImage').value || ''"
                    [src]="form?.get('firstImage').value"
                    class="frame1-bottom-image"
                    height="100%"
                    width="100%"
                  />
                  <div
                    [hidden]="!form?.get('secondImage').value"
                    class="swiper-container"
                  >
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img
                          *ngIf="form?.get('firstImage').value"
                          [src]="form?.get('firstImage').value || ''"
                          class="frame1-bottom-image"
                          height="100%"
                          width="100%"
                        />
                      </div>
                      <div
                        class="swiper-slide"
                        [hidden]="!form?.get('secondImage').value"
                      >
                        <img
                          *ngIf="form?.get('secondImage').value"
                          [src]="form?.get('secondImage').value || ''"
                          class="frame1-bottom-image"
                          height="100%"
                          width="100%"
                        />
                      </div>
                      <div
                        class="swiper-slide"
                        [hidden]="!form?.get('thirdImage').value"
                      >
                        <img
                          *ngIf="form?.get('thirdImage').value"
                          [src]="form?.get('thirdImage').value || ''"
                          class="frame1-bottom-image"
                          height="100%"
                          width="100%"
                        />
                      </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination"></div>
                  </div>
                </div>
                <div
                  [hidden]="form && form.get('type').value !== 'Map View'"
                  id="gmap"
                  #gmap
                  style="width:201px; height:301px;"
                ></div>
                <iframe
                  *ngIf="form && form.get('type').value === 'Web View'"
                  style="width:201px; height:301px;"
                  [src]="siteUrl"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
                <div *ngIf="form" class="button-container">
                  <button>
                    {{ form.get("dismissText").value | uppercase | slice: 0:5 }}
                  </button>
                  <button
                    (click)="firstButtonClick()"
                    *ngIf="form.get('firstButtonType').value"
                  >
                    {{
                      form.get("firstButtonText").value
                        | uppercase
                        | slice: 0:12
                    }}
                  </button>
                  <button
                    (click)="secondButtonClick()"
                    *ngIf="form.get('secondButtonType').value"
                  >
                    {{
                      form.get("secondButtonText").value
                        | uppercase
                        | slice: 0:12
                    }}
                  </button>
                </div>
              </app-iphone-frame>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      *ngIf="id == null && form"
      (click)="checkout()"
      type="button"
      class="btn btn-primary"
      [disabled]="form.invalid"
    >
      Create
    </button>
    <button
      *ngIf="id != null && form"
      (click)="checkout()"
      type="button"
      class="btn btn-primary"
      [disabled]="form.invalid"
    >
      Update
    </button>
    <button [disabled]="loading" (click)="navigateUp()" type="button" class="btn btn-danger" style="margin-left: 15px;">
      Cancel
    </button>
    <app-network-sync [serviceId]="serviceId" [displayCountdown]="false" [viewRef]="viewRef" [serviceName]="'UPN'" [controllerPath]="'upn'"></app-network-sync>
  </div>
</div>
